module.exports = __webpack_public_path__ + "static/media/dallas-reedy-F2HTC_CF4Jo-unsplash.380e5213.jpg";